import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getGift } from "./networkCalls.gift";

const Gift = () => {
  const navigate = useNavigate();
  const { token,journey_type } = useParams();

  useEffect(() => {
    if (token !== null && token !== "") {
      // localStorage.setItem("origin", "internal");
      getGift(token)
        .then((result) => {
          localStorage.clear()
          const { msg, token } = result.data;
      
          if (msg === "generated" && token) {
            localStorage.setItem("token", token);
            localStorage.setItem("origin", "external");
            return navigate(`/user/findContact/`+journey_type);
          }
        })
        .catch((err) => console.log(err));

      // localStorage.setItem("token", token);
      // return navigate("/user/findcontact");
    }
  }, []);
  return <></>;
};

export default Gift;
